module.exports = __webpack_public_path__ + "static/media/info.7d4753df.svg";